import { render, staticRenderFns } from "./pindaan-a.vue?vue&type=template&id=c4e1d874&"
import script from "./pindaan-a.vue?vue&type=script&lang=js&"
export * from "./pindaan-a.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports